import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {
  deductionsPath: () => 'api/driverPay/deductions',
  deductionOrderPath: () => 'api/driverPay/deductions/ChangeOrder',
  defermentOrderPath: () => 'api/driverPay/deductions/ChangeDefermentRepaymentOrder',
  deductionEnabledStatePath: () => 'api/driverPay/deductions/SetEnabledState',
  deductionPathById: (id) => `api/driverPay/deductions/${id}`,
  deductionRestorePath: (id) => `api/driverPay/deductions/${id}/restore`,
  deductionAuditsPathById: (id, params) => `/api/driverPay/deductions/${id}/Audits${getQueryParams(params)}`,
  deductionAuditPropertiesPathById: (id) => `/api/driverPay/deductions/${id}/Audits/Properties`,
  deductionAuditUsersPathById: (id) => `/api/driverPay/deductions/${id}/Audits/Users`,
  deductionRulesPath: () => 'api/driverPay/deductions/Rules',
  deductionsLookup: () => '/api/driverPay/Deductions/Lookup',
};

export const getDeductions = (params) =>
  makeRequest(authFetch.get(`${routes.deductionsPath()}${getQueryParams(params)}`));

export const getDeductionById = (id) => makeRequest(authFetch.get(routes.deductionPathById(id)));

export const postDeduction = (deduction) => makeRequest(authFetch.post(routes.deductionsPath(), deduction));

export const updateDeduction = (deduction) => makeRequest(authFetch.put(routes.deductionsPath(), deduction));

export const changeDeductionOrder = (deduction) => makeRequest(authFetch.patch(routes.deductionOrderPath(), deduction));

export const changeDefermentOrder = (deferment) => makeRequest(authFetch.patch(routes.defermentOrderPath(), deferment));

export const changeDeductionEnabledState = (deduction) =>
  makeRequest(authFetch.patch(routes.deductionEnabledStatePath(), deduction));

export const deleteDeduction = (id) => makeRequest(authFetch.delete(routes.deductionPathById(id)));

export const getDeductionAudits = (id, params) =>
  makeRequest(authFetch.get(routes.deductionAuditsPathById(id, params)));

export const getDeductionAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.deductionAuditPropertiesPathById(id)));

export const getDeductionAuditUsers = (id) => makeRequest(authFetch.get(routes.deductionAuditUsersPathById(id)));

export const getDeductionRules = () => makeRequest(authFetch.get(routes.deductionRulesPath()));

export const getDeductionsLookup = () => makeRequest(authFetch.get(routes.deductionsLookup()));
